import type { PlayerTeamFirstMatchup } from '../../utils/playerTeamId.utils';

type MatchupLabelProps = {
  matchup: PlayerTeamFirstMatchup;
};

function MatchupLabel({ matchup }: MatchupLabelProps) {
  const leftNode =
    matchup.highlightedAlias === matchup.leftAlias ? (
      <strong>{matchup.leftAlias}</strong>
    ) : (
      matchup.leftAlias
    );
  const rightNode =
    matchup.highlightedAlias === matchup.rightAlias ? (
      <strong>{matchup.rightAlias}</strong>
    ) : (
      matchup.rightAlias
    );

  return (
    <>
      {leftNode} {matchup.separator} {rightNode}
    </>
  );
}

export { MatchupLabel };
